import type { ReactNode } from 'react';

import { SimpleHtml } from '#src/app/shared/components/html';
import { isError } from '#src/app/shared/utils/async';

import type { FormState } from '../shared/types';

type Field = 'email' | 'password';

export function getError(field: Field, formState?: FormState): ReactNode {
	if (!formState || !isError(formState)) return undefined;

	const fieldError = formState[field];
	return fieldError ? <SimpleHtml html={fieldError} /> : undefined;
}
